import {register} from '@shopify/theme-sections';

const selectors = {
  slider: '[data-slider]',
};

export default register('featured-collections', {
  onLoad() {
    const container = this.container;
    const elem = container.querySelector(selectors.slider);
    if (!elem) return;
    return new Flickity(elem, {
      freeScroll: false,
      prevNextButtons: true,
      pageDots: true,
      imagesLoaded: true,
      cellAlign: 'left',
      contain: true,
      groupCells: true,
    });
  },
});
